import { Inject, Injectable } from '@angular/core';
import { APP_STORE_CONFIG_TOKEN } from '@ddt-web/config';
import { ApiService, AppStoreConfig } from '@ddt-web/data-service';
import { WebUserDataConstants } from '@ddt-web/domain';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SharedEngagementsConstants } from '../../constants/shared-engagements.constants';
import { BpasEngagement } from '../../domain/bpas-engagement.model';
import { mapFetchUserDataResponseToBpasEngagementList } from '../../domain/mappings/bpas-engagement-mappings';
import { mapBpasEngagementsToUpdateEngagementRequest } from '../../domain/mappings/engagement-request-mappings';
import { EngagementRequest } from '../../domain/requests/engagement-request.model';
import { GetEngagementRequest } from '../../domain/requests/get-engagement-request.model';
import { UpdateEngagementRequest } from '../../domain/requests/update-engagement-request.model';

@Injectable({
	providedIn: 'root'
})
export class EngagementsDataService {

	constructor(
		private apiService: ApiService,
		@Inject(APP_STORE_CONFIG_TOKEN) public storeConfig: AppStoreConfig
	) { }

	public readonly GET_USER_ENGAGEMENTS_RC: string = 'portfolio-centre:bpas:get-all-user-engagements';
	public readonly GET_ENGAGEMENT_RC: string = 'portfolio-centre:bpas:get-engagement';
	public readonly NEW_RECORD_RC: string = 'portfolio-centre:new-data';

	public loadAllUserEngagements(): Observable<BpasEngagement[]> {
		return this.getEngagements(null, this.GET_USER_ENGAGEMENTS_RC);
	}

	public loadOneUserEngagement(uniqueId: string): Observable<BpasEngagement[]> {
		return this.getEngagements(uniqueId, this.GET_ENGAGEMENT_RC);
	}

	public saveMultipleExistingEngagements(engagements: BpasEngagement[]): Observable<BpasEngagement[]> {
		return this.updateEngagement(SharedEngagementsConstants.UPDATE_MODE.EDIT, engagements, '', WebUserDataConstants.USER_DATA_URL.EDIT);
	}

	public saveExistingEngagement(engagement: BpasEngagement): Observable<BpasEngagement[]> {
		return this.updateEngagement(SharedEngagementsConstants.UPDATE_MODE.EDIT, [engagement], '', WebUserDataConstants.USER_DATA_URL.EDIT);
	}

	public addNewEngagement(engagement: BpasEngagement): Observable<BpasEngagement[]> {
		return this.updateEngagement(SharedEngagementsConstants.UPDATE_MODE.NEW, [engagement], this.NEW_RECORD_RC, WebUserDataConstants.USER_DATA_URL.ADD);
	}

	private updateEngagement(action: string, engagement: BpasEngagement[], rc: string, url: string): Observable<BpasEngagement[]> {
		const engagementsRequest: EngagementRequest[] = mapBpasEngagementsToUpdateEngagementRequest(engagement, action);
		const request = {
			datas: engagementsRequest,
			rcs: rc
		} as UpdateEngagementRequest;

		return this.apiService.savePortfolio(url, request).pipe(map(mapFetchUserDataResponseToBpasEngagementList));
	}

	private getEngagements(uniqueId: string, rc: string): Observable<BpasEngagement[]> {
		const request = {
			includeChildren: true
		} as GetEngagementRequest;

		if (uniqueId) {
			request.uniqueId = uniqueId;
		}

		return this.apiService.fetchUserData(WebUserDataConstants.USER_DATA_URL_SHORT.GET_ALL, request, rc).pipe(map(mapFetchUserDataResponseToBpasEngagementList));
	}
}
